
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function BankDetails() {
  const bankAccounts = [
    {
      bankName: 'Republic Bank Barbados',
      accountNumber: '000-456-789',
      accountType: 'Chequing',
      swiftBic: 'RBTTBBSX',
      color: 'bg-blue-500'
    },
    {
      bankName: 'CIBC FirstCaribbean',
      accountNumber: '2244-3355-991',
      accountType: 'Savings',
      swiftBic: 'FCIBBBSX',
      color: 'bg-green-500'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-gradient-to-r from-green-600 to-green-800 text-white py-16"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/b3271db91ce53e326ffb7a58f93d1e9b.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-green-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">MGMT University Bank Account Information</h1>
          <p className="text-xl max-w-4xl leading-relaxed">
            Below are the banking details required for students to complete payments. Please ensure all payment references contain your FULL Student ID Number to prevent posting delays.
          </p>
        </div>
      </section>

      {/* Bank Details Cards */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {bankAccounts.map((bank, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className={`${bank.color} p-6 text-white`}>
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                      <i className="ri-bank-line text-white text-xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold">{bank.bankName}</h3>
                  </div>
                </div>
                
                <div className="p-6 space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Account Number</label>
                      <p className="text-xl font-mono font-bold text-gray-900 mt-1">{bank.accountNumber}</p>
                    </div>
                    <div>
                      <label className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Account Type</label>
                      <p className="text-lg font-semibold text-gray-900 mt-1">{bank.accountType}</p>
                    </div>
                  </div>
                  
                  <div>
                    <label className="text-sm font-semibold text-gray-600 uppercase tracking-wide">SWIFT/BIC Code</label>
                    <p className="text-xl font-mono font-bold text-gray-900 mt-1">{bank.swiftBic}</p>
                  </div>
                  
                  <div className="pt-4 border-t border-gray-200">
                    <button className="w-full bg-gray-50 hover:bg-gray-100 text-gray-700 font-semibold py-3 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-file-copy-line mr-2"></i>
                      Copy Account Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section className="py-16 bg-red-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-red-100 border-l-4 border-red-500 p-6 rounded-r-lg">
            <div className="flex items-start">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-error-warning-line text-red-600 text-xl"></i>
              </div>
              <div className="ml-3">
                <h3 className="text-lg font-semibold text-red-800 mb-4">IMPORTANT NOTE</h3>
                <p className="text-red-700 mb-4">
                  <strong>Always include your Student ID Number</strong> in the reference/description section of the transfer.
                </p>
                <div className="bg-white p-4 rounded-lg border border-red-200">
                  <p className="text-sm text-gray-600 mb-2">Example Reference Format:</p>
                  <p className="font-mono text-sm bg-gray-50 p-3 rounded border">
                    "ID#: 821012345 – Tuition Payment Semester 1"
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Instructions */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Payment Instructions</h2>
            <p className="text-lg text-gray-600">Follow these steps for successful payment processing</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Select Bank Account</h3>
              <p className="text-gray-600">Choose either Republic Bank or CIBC FirstCaribbean account for your payment</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Include Student ID</h3>
              <p className="text-gray-600">Always add your full Student ID Number in the payment reference field</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Keep Receipt</h3>
              <p className="text-gray-600">Save your payment confirmation or receipt for your records</p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Actions */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Next Steps</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <a
              href="/how-to-pay"
              className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer group text-center"
            >
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-bank-card-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Payment Methods</h3>
              <p className="text-gray-600 text-sm">Learn how to make payments</p>
            </a>
            
            <a
              href="/deadlines"
              className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer group text-center"
            >
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-calendar-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Payment Deadlines</h3>
              <p className="text-gray-600 text-sm">Check important dates</p>
            </a>
            
            <a
              href="/contact"
              className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer group text-center"
            >
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-customer-service-line text-white text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Need Help?</h3>
              <p className="text-gray-600 text-sm">Contact student accounts</p>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
